import { makeStyles } from "@material-ui/core";
import { ResponsivePie } from "@nivo/pie";
import { DashboardHeader } from "pages/admin/dashboard/components/general";
import { useEffect, useState } from "react";

const useStyles = makeStyles((theme) => ({
  wrapChart: {
    width: "100%",
    height: "calc(100% - 35px)",
  },
  chart: {
    width: "100%",
    height: "100%",
  },
  description: {

    // fontSize: "18px",
    fontSize: "1.2vmin",
    // fontSize: "calc(1vw + 1vh + 2vmin)",
    fontWeight: 400,
    color: '#333333',
    textAlign: 'center',
    width: '100%',
    marginTop: -25
  }
}));

const CenteredMetric = ({ dataWithArc, centerX, centerY }) => {
  let total = 0;
  dataWithArc.forEach((datum) => {
    total += datum.value;
  });

  return (
    <text
      x={centerX}
      y={centerY}
      textAnchor="middle"
      dominantBaseline="central"
      lengthAdjust="spacingAndGlyphs"
      style={{
        fontSize: "25px",
        fontWeight: 600,
      }}
    >
      {total}
    </text>
  );
};

const Footer = (description) => ({ dataWithArc, centerX, centerY, radius, ...rest }) => {
  return (
    <text
      x={centerX}
      y={centerY + radius + 25}
      textAnchor="middle"
      dominantBaseline="central"
      wordSpacing="wrap"
      style={{
        fontSize: "18px",
        fontWeight: 400,
      }}
    >
      {description}
    </text>
  );
};

const RequestPieChart = ({ data /* see data tab */, description }) => (
  <ResponsivePie
    data={data}
    margin={{ top: 10, right: 20, bottom: 20 + 25, left: -50 }}
    innerRadius={0.7}
    borderColor={{ from: "color", modifiers: [["darker", "0.2"]] }}
    padAngle={1}
    enableArcLinkLabels={false}
    arcLinkLabelsSkipAngle={11}
    arcLinkLabelsTextColor="#333333"
    arcLinkLabelsThickness={2}
    arcLinkLabelsColor={{ from: "color", modifiers: [] }}
    arcLabelsRadiusOffset={0.45}
    arcLabelsTextColor={{ from: "color", modifiers: [["brighter", "3"]] }}
    colors={data.map((x) => x.color)}
    layers={["arcs", "arcLabels", "arcLinkLabels", "legends", CenteredMetric, /*Footer(description)*/]}
    legends={[
      {
        anchor: "right",
        direction: "column",
        justify: false,
        translateX: 0,
        translateY: -2,
        itemsSpacing: 0,
        itemWidth: 103,
        itemHeight: 20,
        itemTextColor: "#999",
        itemDirection: "left-to-right",
        itemOpacity: 1,
        symbolSize: 17,
        symbolShape: "circle",
        effects: [
          {
            on: "hover",
            style: {
              itemTextColor: "#000",
            },
          },
        ],
      },
    ]}
  />
);

function SummaryPieChart(props) {
  const classes = useStyles();
  const _data = props?.data;
  const [data, setData] = useState([]);

  useEffect(() => {
    if (_data?.length > 0) {
      setData(_data);
    }
  }, [_data]);

  return (
    <>
      <div>
        <DashboardHeader
          title={props.title}
          titleColor={'#333333'}
          onSelectViewAll={() => {
            props.onSelectViewAll();
          }}
        />
      </div>
      <div className={classes.wrapChart}>
        <RequestPieChart data={data} className={classes.chart} description={props.description} />
      </div>
      <h6 className={classes.description}>{props.description}</h6>
    </>
  );
}

export default SummaryPieChart;
